import { render, staticRenderFns } from "./BranchDataForm.vue?vue&type=template&id=20c359d3&"
import script from "./BranchDataForm.vue?vue&type=script&lang=js&"
export * from "./BranchDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports